import { z } from "zod";
import { homeChargingDataPointTypeSchema } from "../_shared";

export const uploadDataPointsFilesOfATypeForHomeChargingPayloadSchema =
  z.object({
    requestUuid: z.uuid(),
    type: homeChargingDataPointTypeSchema,
    from: z.iso.datetime(),
    to: z.iso.datetime(),
    vins: z.array(z.string()),
  });

export type UploadDataPointsFilesOfATypeForHomeChargingPayload = z.infer<
  typeof uploadDataPointsFilesOfATypeForHomeChargingPayloadSchema
>;
